export const colStart = (index: number, length: number) => {
    const patternIndex = index % 7;
    const isFullSeven = length - index >= 7 - patternIndex;

    if (patternIndex === 0) {
        return 1;
    }
    if (patternIndex === 1) {
        return isFullSeven ? 3 : 2;
    }
    if (patternIndex === 2) {
        return isFullSeven ? 4 : 3;
    }
    if (patternIndex === 3) {
        return isFullSeven ? 5 : 4;
    }
    if (patternIndex === 4) {
        return isFullSeven ? 3 : 5;
    }
    if (patternIndex === 5) {
        return isFullSeven ? 4 : 1;
    }

    return 5;
};

export const colEnd = (index: number, length: number) => {
    const patternIndex = index % 7;
    const isFullSeven = length - index >= 7 - patternIndex;

    if (patternIndex === 0) {
        return isFullSeven ? 3 : 1;
    }
    if (patternIndex === 1) {
        return isFullSeven ? 3 : 2;
    }
    if (patternIndex === 2) {
        return isFullSeven ? 4 : 3;
    }
    if (patternIndex === 3) {
        return isFullSeven ? 5 : 4;
    }
    if (patternIndex === 4) {
        return isFullSeven ? 3 : 5;
    }
    if (patternIndex === 5) {
        return isFullSeven ? 4 : 1;
    }

    return 5;
};

export const isCardBig = (index: number, length: number) => {
    const patternIndex = index % 7;
    const isFullSeven = length - index >= 7 - patternIndex;
    if (patternIndex === 0) {
        return !!isFullSeven;
    }
    return false;
};

export default { colStart, colEnd, isCardBig };
